import moment from "moment";
import { DayPickerSingleDateController } from "react-dates";
import Icon from "src/components/field/utils/Icon";
import { ucFirst } from "src/lib/formatters";

interface CalendarProps {
	value: string;
	onChange: (value: string) => void;
}

const Calendar = ({ value, onChange }: CalendarProps) => {
	const calendarProps: any = {
		date: value ? moment(value) : null,
		numberOfMonths: 1,
		enableOutsideDays: true,
		focused: true,
	};

	return (
		<div className="day-picker">
			<DayPickerSingleDateController
				{...calendarProps}
				initialVisibleMonth={value ? () => moment(value) : undefined}
				renderNavPrevButton={(props) => (
					<div {...props} className="nav-button nav-button-left">
						<Icon
							icon="far fa-arrow-left"
							className="cursor-pointer"
						/>
					</div>
				)}
				noBorder
				renderNavNextButton={(props) => (
					<div {...props} className="nav-button nav-button-right">
						<Icon
							icon="far fa-arrow-right"
							className="cursor-pointer"
						/>
					</div>
				)}
				onDateChange={(date) => {
					onChange(date ? date.format("YYYY-MM-DD") : "");
				}}
				renderMonthElement={(params) => {
					return (
						<span className="relative px-2 h-8 rounded-md">
							<sup
								className="text-[14px] opacity-20 absolute -right-4"
								style={{ lineHeight: "16px" }}
							>
								{params.month.year()}
							</sup>
							{ucFirst(params.month.format("MMMM"))}
						</span>
					);
				}}
			/>
		</div>
	);
};

export default Calendar;
